module.exports = __webpack_public_path__ + "static/sc-05-1025e9dba05fccf00b998c6781847a4a.png";